import React, { useState, useRef } from "react";

import DemographicStorymapImage from "./DemographicStorymapImage";
import { useFlowAround } from "./useFlowAround";

import RenderLinkGroups from "@components/DocumentGroup/RenderLinkGroups";

const DemographicDataBody = ({ data }) => {
	const docGroupContainer = useRef();
	const docGroupOverflowContainer = useRef();
	const imageContainer = useRef();
	const docGroupClass = "overflow-doc-group";
	const docGroupContainerClass = "overflow-doc-group-container";
	const [imgState, setImgState] = useState("initial");

	const {
		storymapLinkHeader,
		storymapUrl,
		mainBodyText,
		documentGroups,
		additionalInformationLinks,
		additionalInformationHeader,
	} = data;

	useFlowAround(
		{
			flowAroundContainer: imageContainer,
			mainGroupContainer: docGroupContainer,
			overflowGroupContainer: docGroupOverflowContainer,
			subGroupClass: docGroupClass,
			groupContainerClass: docGroupContainerClass,
		},
		imgState
	);

	return (
		<>
			<h1 className="sr-only">Demographic Data</h1>
			<div>{mainBodyText}</div>
			<div className="row">
				<div
					ref={docGroupContainer}
					className="col-12 col-xl-6 w-100 d-flex flex-col justify-content-center"
				>
					{
						<RenderLinkGroups
							linkGroupContainerClass={docGroupContainerClass}
							linkGroupClass={docGroupClass}
							colSpan={12}
							groups={documentGroups}
						/>
					}
				</div>
				<div className="col-12 col-xl-6">
					<div
						className="my-3 mx-auto d-flex flex-row justify-content-center justify-content-xl-start"
						ref={imageContainer}
					>
						<DemographicStorymapImage
							url={storymapUrl}
							header={storymapLinkHeader}
							onLoad={setImgState}
						/>
					</div>
				</div>
			</div>
			<div ref={docGroupOverflowContainer}>
				<RenderLinkGroups
					linkGroupContainerClass={docGroupContainerClass}
					linkGroupClass={docGroupClass}
					colSpan={12}
					groups={[]}
				/>
			</div>
			{additionalInformationHeader}
			<ul className="d-lg-flex flex-row justify-content-center list-unstyled">
				{additionalInformationLinks.map(({ id, url, displayText }) => (
					<li key={id} className="card p-3 m-2 h-100 text-center">
						<a href={url}>{displayText}</a>
					</li>
				))}
			</ul>
		</>
	);
};

export default DemographicDataBody;
